import { useEffect, useRef, useState } from "react";

export const useShowTooltip = <T extends HTMLElement>() => {
  const ref = useRef<T>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const checkTruncate = () => {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    };

    checkTruncate();
    window.addEventListener("resize", checkTruncate);

    return () => {
      window.removeEventListener("resize", checkTruncate);
    };
  }, []);

  return { ref, isTruncated };
};
